const search = {
    mixins: [mixins],
    data() {
        return {
            value: "",
            keyword: "",
            handler: "",
            errorMsgs: [],
            records: [],
            loading: true,
            page: 1,
            allItems: 0,
        };
    },
    mounted() {
        this.value = jQuery(".b-search input", jQuery(this.$el)).attr("data-keyword");

        this.doSearch();
    },
    methods: {
        doSearch() {
            this.loading = true;
            this.errorMsgs = [];

            try {
                axios
                    .get(this.handler + "?keyword=" + this.keyword + "&page=" + this.page)
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        this.keyword = this.value;

                        this.value = response.data.term;

                        this.handleSuccess(data, allItems);
                    })
                    .catch((errors) => {
                        this.handleError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }
        },

        handleError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },

        handleSuccess(data, allItems) {
            this.records = [];

            this.$nextTick(() => {
                this.allItems = parseInt(allItems);
                this.records = [].concat(...data);
            });
        },

        clearInput() {
            this.value = "";
        },

        pageChanged(newPage) {
            this.page = newPage;

            this.doSearch();
            this.scrollToElem(jQuery(this.$el));
        },

        submitWithEnter() {
            jQuery(".b-search input").keypress(function (e) {
                if (e.which == 13) {
                    jQuery(".b-search form").submit();
                    return false;
                }
            });
        },
    },

    computed: {
        searchBtnDisabled() {
            if (this.value.length > 0) {
                return false;
            }
            return true;
        },
    },
};

var searchApp = Vue.createApp(search);
if (document.querySelector("#v-search")) {
    searchApp.directive("init", initDirective);

    searchApp.component("b-pagination", bPagination);
    searchApp.mount("#v-search");
}
